<template>
  <div class="uploading-page">
    <div class="img-box">
      <h1>{{ content !== null ? content : '檔案上傳中'/* ___ */ }}</h1>
      <img :src="require('../../assets/images/upload.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/uploading.vue